import { ContextManager } from "~/modules/contextManager/ContextManager";
import { refreshToken } from "./refreshToken";
import type { RefreshTokenParams, RefreshTokenResponse } from "./types";

export const refreshTokenWrapper = async (options: RefreshTokenParams): Promise<RefreshTokenResponse> => {
    return refreshToken(ContextManager.newInstance())(options);
};
